import { createFileRoute } from '@tanstack/react-router'

import { HomeContentContainer } from '@/components'
import { BillView } from '@/components/pages/Admin/BillManagement/View/BillView'
import { useGetBillById } from '@/modules/bill/services/bill'
import { useTranslations } from '@/hooks/useTranslations'

export const Route = createFileRoute('/(dashboard)/admin/bill/$id/')({
  component: BillViewPage,
})

function BillViewPage() {
  const { id } = Route.useParams()
  const { data } = useGetBillById(id)
  const t = useTranslations('admin.bill_management')

  return (
    <HomeContentContainer
      title={t('bill_detail_title')}
      subtitle={t('bill_detail_subtitle')}
      contentClassName="max-w-full"
    >
      <BillView data={data} />
    </HomeContentContainer>
  )
}

